const getApiDomain = () => {
  switch (window.location.hostname) {
    case 'dev.portal.payactive.io':
      return 'https://dev.api.payactive.io';
    case 'portal.dev.payactive.app':
      return 'https://api.dev.payactive.app';
    case 'stage.portal.payactive.io':
      return 'https://stage.api.payactive.io';
    case 'portal.payactive.io':
      return 'https://api.payactive.io';
    case 'portal.payactive.eu':
      return 'https://api.payactive.io';
    case 'portal.payactive.app':
      return 'https://api.payactive.app';
    case 'sandbox.portal.payactive.io':
      return 'https://sandbox.api.payactive.io';
    case 'portal.sandbox.payactive.app':
      return 'https://api.sandbox.payactive.app';
    default:
      return 'http://localhost:8080';
  }
};

const getAuthDomain = () => {
  switch (window.location.hostname) {
    case 'portal.dev.payactive.app':
      return 'https://auth.dev.payactive.app';
    case 'portal.sandbox.payactive.app':
      return 'https://auth.sandbox.payactive.app';
    case 'portal.payactive.eu':
      return 'https://auth.payactive.eu';
    case 'portal.payactive.app':
      return 'https://auth.payactive.app';
    case 'localhost':
      return 'https://auth.dev.payactive.app';
  }
}

const getAuthRealm = () => {
  switch (window.location.hostname) {
    case 'localhost':
      return 'payactive_local';
    default:
      return 'payactive';
  }
}

const getTracingDomain = () => {
  switch (window.location.hostname) {
    case 'portal.dev.payactive.app':
      return 'https://tracing.dev.payactive.app';
    case 'portal.sandbox.payactive.app':
      return 'https://tracing.sandbox.payactive.app';
    case 'portal.payactive.eu':
      return 'https://tracing.payactive.eu';
    case 'portal.payactive.app':
      return 'https://tracing.payactive.app';
  }

  return 'http://localhost:3217';
};

const getEnv = () => {
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }

  switch (window.location.hostname) {
    case 'portal.dev.payactive.app':
    case 'dev.portal.payactive.io':
      return 'dev';
    case 'stage.portal.payactive.io':
      return 'stage';
    case 'portal.sandbox.payactive.app':
    case 'sandbox.portal.payactive.io':
      return 'sandbox';
    case 'portal.payactive.app':
    case 'portal.payactive.io':
      return 'prod';
    default:
      return 'dev';
  }
};

export { getApiDomain, getAuthDomain, getAuthRealm, getTracingDomain, getEnv };
